export function initPostFilters() {
  console.log('initPostFilters');
	// Search Clear
	let searchContainer = document.querySelector('.alm-filter--search .alm-filter--text');
	let searchInput = searchContainer.querySelector('input.alm-filter--textfield');
	let searchClearElem = document.createElement('div');
	searchClearElem.classList.add('clear-search', 'hidden');
	searchClearElem.innerHTML = '<i class="fa-solid fa-xmark"></i>';
	searchContainer.appendChild(searchClearElem);

	if (searchInput) {
		searchInput.addEventListener('input', function (e) {
			if(searchInput.value) {
				searchClearElem.classList.remove('hidden');
				searchClearElem.classList.add('block');
			} else {
				searchClearElem.classList.remove('block');
				searchClearElem.classList.add('hidden');
			}
		});
	}

	if (searchClearElem) {
		searchClearElem.addEventListener('click', function(){
			searchInput.value = '';
			searchClearElem.classList.remove('block');
			searchClearElem.classList.add('hidden');
			setTimeout(() => {
				searchInput.focus();
			}, 1);
		});
	}

	// Reset Filters
	let filterResets = document.querySelectorAll('.reset-filters');
	for (const filterReset of filterResets) {
		if(filterReset) {
			filterReset.addEventListener('click', function(e){
				almfilters.reset();
				searchClearElem.classList.remove('block');
				searchClearElem.classList.add('hidden');
			});
		}
	}

	// Helper getClosest parent function 
	var getClosest = function (elem, selector) {
		for ( ; elem && elem !== document; elem = elem.parentNode ) {
			if ( elem.matches( selector ) ) return elem;
		}
		return null;
	};
	

	// JS Dropdowns
	let filterGroups = document.querySelectorAll('.alm-filter--group');
	let filterID;
	let otherGroups;

	document.addEventListener('click', function(e){
		let self = e.target;
		let selfGroup = getClosest(self, '.alm-filter--group');

		if(selfGroup) {
			// Set up empty array for all non-selected filter groups
			otherGroups = [];

			// Get selected filter group ID
			filterID = selfGroup.id;
	
			// Add non-selected filter groups to array
			for (const filterGroup of filterGroups) {
				if (filterGroup.id !== filterID) {
					otherGroups.push(filterGroup);
				}
			}
			
			// Remove class 'open' from all non-selected filter groups
			for (const otherGroup of otherGroups) {
				otherGroup.classList.remove('open');
			}

			// If already open && we're clicking the title, close it; otherwise open
			// And for any other outside clicks, close everything
			if(selfGroup.classList.contains('open') && self.closest('.alm-filter--title')) {
				selfGroup.classList.remove('open');
			} else {
				selfGroup.classList.add('open');
			}
		} else {
			for (const filterGroup of filterGroups) {
				filterGroup.classList.remove('open');
			}
		}		
	});

  // ===========================================================================
  // Truncate Pagination
  // ===========================================================================

  window.almComplete = function(alm){
    setTimeout(() => {
      let paging = document.querySelector('.alm-paging');
      let pageNums = document.querySelectorAll('.alm-paging [data-page-number]');
      let totalNums = pageNums.length;
      if (pageNums.length < 7) return;
  
      let activeNum = document.querySelector('.alm-paging [data-page-number].active');
      let activeNumData = parseInt(activeNum.getAttribute('data-page-number'));
      let activeNumIndex = activeNumData - 1;
      let nearestNums = [];
  
      // console.log('activeNumData: '+activeNumData);
      // console.log('pageNums.length: '+pageNums.length);
  
      nearestNums.push(activeNum);
  
      for (let i = 0; i < pageNums.length; i++) {
        let pageNum = pageNums[i];
        let pageNumData = parseInt(pageNum.getAttribute('data-page-number'));
  
        pageNum.classList.add('truncated');
        pageNum.style.display = 'inline-block';
  
        // Keep first and last 2 items, no matter what
        if (activeNumData < 3) {
          if (i == 0 || i == 1 || i == 2 || i == pageNums.length - 1) {
            nearestNums.push(pageNum);
          }
        } else {
          if (i == 0 || i == pageNums.length - 1) {
            nearestNums.push(pageNum);
          } 
        }
  
        // Get nearest items to active page number
        if (i == activeNumIndex - 1 || i == activeNumIndex + 1) {
          nearestNums.push(pageNum);
        }
        // if (activeNumData > 1 && activeNumData < pageNums.length) {
        // }
      }
  
      for (const nearestNum of nearestNums) {
        nearestNum.classList.remove('truncated');
      }
  
      if (document.querySelector('.ellipse')) {
        let ellipseElemsBeforeSearch = document.querySelectorAll('.ellipse--before');
        for (const ellipseElemBefore of ellipseElemsBeforeSearch) {
          ellipseElemBefore.remove();        
        }
        let ellipseElemsAfterSearch = document.querySelectorAll('.ellipse--after');
        for (const ellipseElemAfter of ellipseElemsAfterSearch) {
          ellipseElemAfter.remove();        
        }
      }
  
      if(activeNumData > 3) {
        let ellipseElemBefore = document.createElement('div');
        ellipseElemBefore.classList.add('ellipse', 'ellipse--before');
        ellipseElemBefore.innerHTML = "...";
        for (let i = 0; i < pageNums.length; i++) {
          let pageNum = pageNums[i];
          if (i == activeNumIndex - 2) {
            pageNum.before(ellipseElemBefore);  
          }
        }
      }
  
      if(activeNumData < totalNums - 2) {
        let ellipseElemsAfter = document.createElement('div');
        ellipseElemsAfter.classList.add('ellipse', 'ellipse--after');
        ellipseElemsAfter.innerHTML = "...";
        for (let i = 0; i < pageNums.length; i++) {
          let pageNum = pageNums[i];
          if (i == activeNumIndex + 2) {
            pageNum.after(ellipseElemsAfter);  
          }
        }
      }
    }, 500);
  }
}